const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const isProd = process.env.NODE_ENV === 'production';
const enableDevSw = process.env.REACT_APP_ENABLE_SW_DEV === 'true';

export function register(config) {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  // CRA does not reliably serve generated service-worker.js in normal dev mode.
  // Keep production as default and allow explicit dev opt-in via env flag.
  if (!isProd && !enableDevSw) {
    console.info('Service worker skipped in development. Set REACT_APP_ENABLE_SW_DEV=true to opt in.');
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);

      navigator.serviceWorker.ready.then(() => {
        console.log('Service worker is active in local mode.');
      });
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

export async function registerBackgroundSync() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.ready;

    if ('periodicSync' in registration && navigator.permissions) {
      try {
        const status = await navigator.permissions.query({ name: 'periodic-background-sync' });
        if (status.state === 'granted') {
          await registration.periodicSync.register('happyears-data-sync', {
            minInterval: 60 * 60 * 1000,
          });
          return;
        }
      } catch (_) {
      }
    }

    if ('sync' in registration) {
      await registration.sync.register('happyears-data-sync-once');
    }
  } catch (error) {
    console.warn('Background sync registration skipped:', error?.message || error);
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            // In development, missing service-worker.js is expected unless explicitly opted in.
            if (isProd) {
              window.location.reload();
            }
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
